export const defualtErrorMessage =
  "Something went wrong please try again later";


export const graphColorList = [
  "#315bbc",
  "#db5943",
  "#41bc66",
  "#bf8523",
  "#e377c2",
  "#17becf",
  "#2ca02c",
  "#ff7f0e",
  "#485c7b",
  "#71649C",
];


export const darkThemeModal = {
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalContent: {
    backgroundColor: "#ooo",
    padding: "24px", // Increased padding
    borderRadius: "8px",
    color: "#ccc",
    width: "80%", // Increased width
    maxHeight: "80%", // Set maximum height
    overflowY: "auto", // Enable vertical scrolling if needed
  },
  documentCard: {
    backgroundColor: "#444",
    padding: "16px",
    borderRadius: "8px",
    marginBottom: "16px",
  },
};
